import gql from "graphql-tag";
import {
  UserFragment,
  EmailFragment,
  PhoneFragment,
  MemoFragment,
  MemoPhotoFragment,
  AlertFragment
} from "./fragments";

import { Query } from "types";
import { createBoundQuery } from "./util";

export const getAppData = gql`
  query getAppData {
    memos{
      ...MemoFragment
    },
    alerts{
      ...AlertFragment
    }
    memoPhotos{
      ...MemoPhotoFragment
    }
    categories{
      id,
      name,
      order,
      icon,
      templates{
        id,
        name,
        order
      }
    },
    currentUser{
      ...UserFragment,
      emails{
        ...EmailFragment
      },
      phones{
        ...PhoneFragment
      },
      clientToken
    }
  }
  ${UserFragment},
  ${MemoFragment},
  ${AlertFragment}
  ${MemoPhotoFragment}
  ${EmailFragment},
  ${PhoneFragment}`;

export namespace appQueries {
  export const AppData = createBoundQuery<Query>(getAppData);
}



// WEBPACK FOOTER //
// ./src/api/query.ts